/* Beauty Source — main product interactions */
(function(){
  'use strict';

  function init(root){
    if(!root || root.dataset.bsInit) return;
    root.dataset.bsInit = '1';

    var productEl = root.querySelector('[data-bs-product-json]');
    var product = null;
    try { product = productEl ? JSON.parse(productEl.textContent) : null; } catch(e){ product = null; }

    /* Gallery */
    var mainImg = root.querySelector('[data-bs-main-img]');
    var zoomOverlay = document.querySelector('.bs-zoom-overlay'); if(!zoomOverlay){ zoomOverlay = document.createElement('div'); zoomOverlay.className = 'bs-zoom-overlay'; zoomOverlay.innerHTML = '<button type="button" class="bs-zoom-close" aria-label="Sluiten">&times;</button><img alt="">'; document.body.appendChild(zoomOverlay); zoomOverlay.addEventListener('click', function(){ zoomOverlay.classList.remove('is-open'); }); } function getZoomSrc(src){ if(/([?&]width=)\d+/.test(src)){ return src.replace(/([?&]width=)\d+/, '$1' + 2000); } return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=2000'; } if(mainImg){ mainImg.style.cursor = 'zoom-in'; mainImg.addEventListener('click', function(){ var zi = zoomOverlay.querySelector('img'); zi.src = getZoomSrc(mainImg.src); zi.alt = mainImg.alt || ''; zoomOverlay.classList.add('is-open'); }); }
    root.querySelectorAll('[data-bs-thumb]').forEach(function(btn){ btn.addEventListener('click', function(){ var src = btn.getAttribute('data-bs-thumb'); var full = btn.getAttribute('data-bs-thumb-full') || src; if(mainImg) mainImg.src = full; root.querySelectorAll('[data-bs-thumb]').forEach(function(b){ b.classList.remove('is-active'); }); btn.classList.add('is-active'); var thumbBase = full.split('?')[0]; var matched = null; root.querySelectorAll('.bs-swatch').forEach(function(swatch){ var img = swatch.querySelector('img'); if(img){ var swatchBase = img.getAttribute('src').split('?')[0]; if(swatchBase === thumbBase){ matched = swatch; } } }); if(matched) matched.click(); }); });

    /* Variants */
    var variantInput = root.querySelector('[data-bs-variant-id]');
    var priceNow = root.querySelector('[data-bs-price]');
    var priceWas = root.querySelector('[data-bs-compare]');
    var atc = root.querySelector('[data-bs-atc]');
    var atcLabel = root.querySelector('[data-bs-atc-label]');
    var qtyInput = root.querySelector('[data-bs-qty]');
    var stickyPrice = document.querySelector('[data-bs-sticky-price]');
    var stickyMeta = document.querySelector('[data-bs-sticky-meta]');

    function fmtMoney(cents){
      var v = (cents/100).toFixed(2).replace('.', ',');
      return '€' + v;
    }

    function selectedOptions(){
      var opts = [];
      root.querySelectorAll('[data-bs-option-index]').forEach(function(group){
        var idx = parseInt(group.getAttribute('data-bs-option-index'),10);
        var active = group.querySelector('.bs-swatch.is-active, .bs-variant__btn.is-active');
        opts[idx] = active ? active.getAttribute('data-bs-option-value') : null;
      });
      return opts;
    }

    function findVariant(opts){
      if(!product || !product.variants) return null;
      return product.variants.find(function(v){
        return (opts[0]==null||v.option1===opts[0]) &&
               (opts[1]==null||v.option2===opts[1]) &&
               (opts[2]==null||v.option3===opts[2]);
      }) || null;
    }

    /* Update het label naast de optienaam (bv. "Kleur — Zwart") */
    function updateSelectedLabels(){
      root.querySelectorAll('[data-bs-option-index]').forEach(function(group){
        var label = group.querySelector('[data-bs-selected-value]');
        if(!label) return;
        var active = group.querySelector('.bs-swatch.is-active, .bs-variant__btn.is-active');
        if(active) label.textContent = active.getAttribute('data-bs-option-value');
      });
    }

    function updateVariant(){
      var opts = selectedOptions();
      var v = findVariant(opts);
      updateSelectedLabels();
      if(!v) return;
      if(variantInput) variantInput.value = v.id;
      if(priceNow) priceNow.textContent = fmtMoney(v.price);
      if(priceWas){
        if(v.compare_at_price && v.compare_at_price > v.price){
          priceWas.textContent = fmtMoney(v.compare_at_price);
          priceWas.style.display = '';
        } else {
          priceWas.style.display = 'none';
        }
      }
      if(atc){
        atc.disabled = !v.available;
        if(atcLabel) atcLabel.textContent = v.available ? 'Toevoegen aan winkelwagen' : 'Uitverkocht';
      }
      /* Hoofdafbeelding meewisselen met de variant */
      if(mainImg && v.featured_image && v.featured_image.src){
        mainImg.src = v.featured_image.src;
      }
      if(stickyPrice) stickyPrice.textContent = fmtMoney(v.price);
      if(stickyMeta && product){
        var vt = (v.title && v.title !== 'Default Title') ? ' · ' + v.title : '';
        stickyMeta.textContent = product.vendor + vt;
      }
      try{
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }catch(e){}
    }

    /* Klik op swatch of tekstknop */
    root.querySelectorAll('.bs-swatch, .bs-variant__btn').forEach(function(btn){
      btn.addEventListener('click', function(){
        var group = btn.closest('[data-bs-option-index]');
        if(!group) return;
        group.querySelectorAll('.bs-swatch, .bs-variant__btn').forEach(function(b){
          b.classList.remove('is-active');
        });
        btn.classList.add('is-active');
        updateVariant();
      });
    });

    /* Qty */
    root.querySelectorAll('[data-bs-qty-step]').forEach(function(btn){
      btn.addEventListener('click', function(){
        if(!qtyInput) return;
        var step = parseInt(btn.getAttribute('data-bs-qty-step'),10);
        var v = parseInt(qtyInput.value,10) || 1;
        v = Math.max(1, Math.min(99, v + step));
        qtyInput.value = v;
      });
    });
    if(qtyInput){
      qtyInput.addEventListener('change', function(){
        var v = parseInt(qtyInput.value,10) || 1;
        qtyInput.value = Math.max(1, Math.min(99, v));
      });
    }

    /* Read more / less — op basis van hoogte, HTML-opmaak blijft intact */
    var descContent = root.querySelector('[data-bs-desc-content]');
    var descToggle = root.querySelector('[data-bs-desc-toggle]');
    if(descContent && descToggle){
      if(descContent.scrollHeight <= descContent.clientHeight + 8){
        descToggle.setAttribute('hidden', '');
      }
      descToggle.addEventListener('click', function(){
        var expanded = descContent.classList.toggle('is-expanded');
        descToggle.textContent = expanded ? 'Lees minder' : 'Lees meer';
        descToggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    }

    /* Add to cart — fetch + Symmetry cart drawer */
    var form = root.querySelector('.bs-product-form, [id="product-form"]');
    if(form){
      form.addEventListener('submit', function(e){
        e.preventDefault();

        var btn = form.querySelector('[name="add"]');
        var label = form.querySelector('[data-bs-atc-label]');
        var original = label ? label.textContent : '';

        if(btn) btn.disabled = true;
        if(label) label.textContent = 'Toevoegen…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form)
        })
        .then(function(r){ return r.json(); })
        .then(function(){
          return fetch('/cart.js', { credentials: 'same-origin' })
            .then(function(r){ return r.json(); });
        })
        .then(function(cart){
          /* Cart counter updaten */
          document.querySelectorAll('.cart-link__count, [data-cart-count], .cart-count, .header__cart-count, .cart-link__bubble-num')
            .forEach(function(el){
              el.textContent = cart.item_count;
              if(cart.item_count > 0){
                el.classList.add('is-visible', 'has-items');
                el.style.display = '';
              }
            });

          /* Symmetry cart drawer openen en refreshen */
          var drawer = document.querySelector('cart-drawer');
          if(drawer){
            var cartForm = drawer.querySelector('cart-form');
            if(cartForm && typeof cartForm.refresh === 'function'){
              cartForm.refresh();
            }
            if(typeof drawer.open === 'function'){
              drawer.open(document.querySelector('.cart-link'));
            }
          }

          if(label) label.textContent = 'Toegevoegd ✓';
          setTimeout(function(){
            if(label) label.textContent = original;
            if(btn) btn.disabled = false;
          }, 1800);
        })
        .catch(function(){
          if(label) label.textContent = original;
          if(btn) btn.disabled = false;
        });
      });
    }

    /* Sticky bar via IntersectionObserver */
    var sticky = document.querySelector('[data-bs-sticky]');
    var sentinel = root.querySelector('.bs-buyrow, .bs-product-form');
    if(sticky && sentinel && 'IntersectionObserver' in window){
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if(e.isIntersecting){ sticky.classList.remove('is-visible'); }
          else { sticky.classList.add('is-visible'); }
        });
      }, { threshold: 0 });
      io.observe(sentinel);
    }

    /* Initial sync */
    updateVariant();
  }

  function boot(){
    document.querySelectorAll('[data-bs-main-product]').forEach(init);
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();